import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { PhysicalDockInventoryItem } from 'contracts/PhysicalDocks';

const { Types, Creators } = createActions(
  {
    request: ['warehouseId', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    reset: [],
  },
  { prefix: 'FETCH_PHYSICAL_DOCK_INVENTORY_' }
);

export interface FetchPhysicalDockInventoryState {
  data: PhysicalDockInventoryItem[];
  loading: boolean;
  errorMessage: string | null;
}

export interface FetchPhysicalDockInventoryRequestAction {
  warehouseId: number;
  onSuccess?: () => boolean | void;
  onFailure?: () => boolean | void;
}

interface SuccessAction {
  data: PhysicalDockInventoryItem[];
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: FetchPhysicalDockInventoryState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: FetchPhysicalDockInventoryState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (
  state: FetchPhysicalDockInventoryState,
  action: SuccessAction
) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (
  state: FetchPhysicalDockInventoryState,
  action: FailureAction
) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const reset = () => INITIAL_STATE;

export const fetchPhysicalDockInventory = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const FetchPhysicalDockInventoryTypes = Types;
export const FetchPhysicalDockInventoryActions = Creators;
